import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.scss";

export default function PrivacyPage() {
  return (
    <div className="netflix-app container-fluid legal-page-shell">
      <article className="legal-page">
        <Link className="legal-page__back" to="/">← Back to dSsTV</Link>
        <h1 className="legal-page__title">Privacy Policy</h1>
        <p className="legal-page__effective">
          <strong>Effective Date:</strong> March 19, 2026
        </p>
        <p className="legal-page__text">
          dataSCIsiveTV respects your privacy and is committed to protecting
          your information. This Privacy Policy explains how we access, collect,
          use, store, and share information when you access or use
          dataSCIsiveTV.
        </p>
        <p className="legal-page__text">
          dataSCIsiveTV uses YouTube API Services.
        </p>

        <div className="legal-page__note">
          For more information about how Google handles personal information,
          please review the{" "}
          <a
            className="legal-page__link"
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Privacy Policy
          </a>
          .
        </div>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">
            Information We Access, Collect, Store, or Use
          </h2>
          <p className="legal-page__text">
            Depending on how you use dataSCIsiveTV, we may access, collect,
            temporarily process, and in limited cases store the following
            information:
          </p>
          <ul className="legal-page__list">
            <li>
              Information you submit directly to use the service, such as search
              queries, URLs, or other inputs you enter.
            </li>
            <li>
              Technical request information needed to operate, secure, and
              troubleshoot the service, such as IP address, browser type, device
              type, pages viewed, timestamps, and referrer information.
            </li>
            <li>
              YouTube API Data returned by YouTube API Services for requested
              features, such as video titles, channel names, thumbnails,
              descriptions, publish dates, and other metadata.
            </li>
          </ul>
          <p className="legal-page__text">
            dataSCIsiveTV does not provide user login accounts and does not
            intentionally access authorized Google account data.
          </p>
          <p className="legal-page__text">
            dataSCIsiveTV does not store personal information beyond what is
            reasonably necessary to operate the service, maintain security,
            troubleshoot issues, and comply with legal obligations.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">How We Use and Process Information</h2>
          <p className="legal-page__text">
            We use and process information to provide, operate, maintain, secure,
            troubleshoot, and improve dataSCIsiveTV, to display YouTube-related
            content and features requested by users, and to comply with legal
            obligations.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">How We Share Information</h2>
          <p className="legal-page__text">
            We may share information only as reasonably necessary to operate,
            host, secure, support, and maintain the service, including with
            infrastructure, hosting, security, and technical service providers
            acting on our behalf, or when required by law, legal process, or to
            protect rights, safety, or security.
          </p>
          <p className="legal-page__text">
            We do not sell personal information or YouTube API Data.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Cookies and Similar Technologies</h2>
          <p className="legal-page__text">
            dataSCIsiveTV does not use first-party login accounts and does not
            intentionally place first-party cookies for user accounts or
            sign-in.
          </p>
          <p className="legal-page__text">
            However, dataSCIsiveTV may display or embed YouTube content or use
            third-party services that store, access, or collect information
            directly or indirectly on or from users&apos; devices or browsers,
            including through cookies or similar technologies, in connection
            with playback, security, measurement, or delivery of content.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Data Retention</h2>
          <p className="legal-page__text">
            We retain information only for as long as reasonably necessary to
            provide the service, maintain security, comply with legal
            obligations, and resolve technical or legal issues.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Contact</h2>
          <p className="legal-page__text">
            If you have questions or complaints about this Privacy Policy or
            our privacy practices, please contact us at{" "}
            <a
              className="legal-page__link"
              href="mailto:s@dataSCIsive.com"
            >
              s@dataSCIsive.com
            </a>.
          </p>
        </section>
      </article>
    </div>
  );
}
